import {
  Avatar as ChakraAvatar,
  AvatarProps as ChakraAvatarProps,
  useColorModeValue,
} from '@cardboard-ui/react';
import React from 'react';
import { graphql } from 'relay-runtime';
import { useFragment } from 'utils/graphClient';
import { CheckCircleIcon } from '../icons';
import { UserAvatar_member$key } from './__generated__/UserAvatar_member.graphql';

const memberFragment = graphql`
  fragment UserAvatar_member on Member {
    name
    email
    avatar: image(width: 750) {
      url
    }
  }
`;

interface DirectUserAvatarProps extends Omit<ChakraAvatarProps, 'src'> {
  avatarUrl?: string;
}

export const DirectUserAvatar = ({
  avatarUrl,
  onError,
  children,
  ...props
}: DirectUserAvatarProps) => {
  return (
    <ChakraAvatar {...props} src={avatarUrl}>
      {children}
    </ChakraAvatar>
  );
};

export const SelectedUserAvatar = () => {
  const bg = useColorModeValue('gray.100', 'gray.800');

  return (
    <ChakraAvatar
      icon={<CheckCircleIcon color="green.500" size="lg" />}
      bg={bg}
    />
  );
};

export interface UserAvatarProps extends ChakraAvatarProps {
  member: UserAvatar_member$key;
}

export const UserAvatar: React.FC<UserAvatarProps> = ({
  children,
  member,
  ...props
}) => {
  const { name, email, avatar } = useFragment(memberFragment, member);

  return (
    <DirectUserAvatar name={name || email} avatarUrl={avatar?.url} {...props}>
      {children}
    </DirectUserAvatar>
  );
};
